export function ReceiptLongIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.25 2.91663L15 1.66663L13.75 2.91663L12.5 1.66663L11.25 2.91663L10 1.66663L8.75 2.91663L7.5 1.66663L6.25 2.91663L5 1.66663V13.3333H2.5V15.8333C2.5 17.2166 3.61667 18.3333 5 18.3333H15C16.3833 18.3333 17.5 17.2166 17.5 15.8333V1.66663L16.25 2.91663ZM12.5 16.6666H5C4.54167 16.6666 4.16667 16.2916 4.16667 15.8333V15H12.5V16.6666ZM15.8333 15.8333C15.8333 16.2916 15.4583 16.6666 15 16.6666C14.5417 16.6666 14.1667 16.2916 14.1667 15.8333V13.3333H6.66667V4.16663H15.8333V15.8333Z"
        fill="currentColor"
      />
      <path d="M12.5 5.83329H7.5V7.49996H12.5V5.83329Z" fill="currentColor" />
      <path d="M15 5.83329H13.3333V7.49996H15V5.83329Z" fill="currentColor" />
      <path d="M12.5 8.33329H7.5V9.99996H12.5V8.33329Z" fill="currentColor" />
      <path d="M15 8.33329H13.3333V9.99996H15V8.33329Z" fill="currentColor" />
    </svg>
  )
}
